import { openKendoWindow, rebindEvent, requestOptional, requestOptionalUrl, enableInputs } from "scripts/Utilities/core";
import { getResource } from "scripts/Utilities/resources";
import { displayMessage, messageType } from "scripts/Utilities/notification";
import { getGrid, getSelectedItemByTr, confirmDelete, removeListViewItem } from "scripts/Utilities/searchTable";

function init() {
    rebindEvent("click", ".toggle-panel", toglePanel);
    rebindEvent("click", ".show-finished-js", showFinishedDocGrid);
    rebindEvent("click", ".show-returned-js", showReturnedDocGrid);
    rebindEvent("click", ".nav-link-js", onProfileMenuLinkClick);
    rebindEvent("click", ".deny-powerofattorney-js", onDenyPowerOfAttorneyClick);
    rebindEvent("click", ".add-agent-popup-js", onAddAgentPopupClick);
    rebindEvent("click", ".upsert-personal-data-js", onChangePersonalDataClick);
    rebindEvent("click", ".add-name-js", onAddNameClick);
    rebindEvent("click", ".remove-name-js", onRemoveNameClick);
    rebindEvent("click", ".check-existence-js", onCheckExistenceClick);
    rebindEvent("click", ".add-role-js", onAddRoleClick);
    rebindEvent("click", ".remove-item-js", removeListViewItem);
    rebindEvent("click", ".upsert-agent-rights-js", onUpsertAgentRightsClick);
    rebindEvent("click", ".account-upsert-address-js", upsertAddress);
    rebindEvent("click", ".account-remove-address-js", removeAddress);
    rebindEvent("click", ".check-username-js", onCheckUserNameClick);
    rebindEvent("click", ".forgotten-password-js", onForgottenPasswordClick);
    rebindEvent("click", ".add-agent-js", onAddAgentClick);
    rebindEvent("click", ".remove-new-agent-js", onRemoveNewAgentClick);
    rebindEvent("click", ".upsert-register-data-js", onUpsertRegisterData);
}

export function onRegisterDataBound(e: kendo.ui.DropDownListDataBoundEvent): void {
    let enable = e.sender.dataSource.total() > 0;
    e.sender.enable(enable);
    e.sender.trigger("change");
    let wrapper = e.sender.wrapper.closest(".form-input");
    if (enable) {
        wrapper.show();
    }
    else {
        wrapper.hide();
    }
}
export function onRegisterDataChange(e: kendo.ui.DropDownListEvent): void {
    let selected = e.sender.value();
    if (selected) {
        $(".register-number").show();
        enableInputs($(".register-number"), true);
    } else {
        $(".register-number").hide();
        enableInputs($(".register-number"), false);
    }
}

function onUpsertRegisterData(e: JQuery.TriggeredEvent) {
    e.preventDefault();

    let sender = $(e.currentTarget);

    openKendoWindow(
        "Upsert",
        "Register",
        {
            data: {
                id: sender.data("id")
            },
        },
        {
            title: getResource("EditAddress"),
            width: "80%",
            resizable: true,
            modal: true,
        });
}

function onForgottenPasswordClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    openKendoWindow(
        "ForgottenPassword",
        "Account",
        {},
        {
            modal: true,
            title: getResource("ForgottenPassword"),
            width: "40%",
            resizable: true,
        });
}

function removeAddress(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let sender = $(e.currentTarget);

    confirmDelete(
        () => {
            requestOptional(
                "DeleteAddress",
                "Account",
                {
                    type: "POST",
                    data: {
                        id: sender.data("id")
                    },
                    success: () => {
                        sender.closest("div.flex").remove();
                        sender.closest("div.doc-row").remove();
                        displayMessage(getResource("DeleteSuccess"), messageType.success);
                    }
                });
            return true;
        });
}

function onCheckUserNameClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();
    let sender = $(e.currentTarget);
    let wrapper = sender.closest(".form-row");
    let username = wrapper.find("[name=UserName]").val();
    if (!username) {
        displayMessage(kendo.format(getResource("Required"), getResource("UserName")), messageType.warning);
        return;
    }

    requestOptional(
        "CheckUserName",
        "Account",
        {
            data: {
                userName: username
            },
            success: (data) => {
                if (data && data.exists) {
                    displayMessage(getResource("ExistMessage"), messageType.warning);
                } else {
                    displayMessage(getResource("NotExistMessage"), messageType.info);
                }
            }
        });
}

function upsertAddress(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let sender = $(e.currentTarget);

    openKendoWindow(
        "UpsertAddress",
        "Account",
        {
            data: {
                id: sender.data("id")
            }
        },
        {
            title: getResource("EditAddress"),
            width: "80%",
            resizable: true,
            modal: true,
        });
}

function onUpsertAgentRightsClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let selectedItem = getSelectedItemByTr($(e.currentTarget).closest("tr"));
    if (!selectedItem) {
        return;
    }

    openKendoWindow(
        "UpsertAgentRights",
        "Account",
        {
            data: {
                agentId: selectedItem["ClientId"],
            }
        },
        {
            title: getResource("EditAgentRights"),
            width: "80%",
            resizable: true,
            modal: true,
        });
}

function toglePanel(e) {
    e.preventDefault();
    $(this).parents('.step-box').eq(0).toggleClass('closed')
}

function showFinishedDocGrid(e) {
    if ($("#ready-documents").hasClass("hidden")) {
        $("#ready-documents").removeClass("hidden");
        $("#returned-documents").addClass("hidden");
        $(".show-returned-js").addClass("third");
        $(".show-finished-js").removeClass("third");
        $("#ready-documents").trigger("resize");
    }
}

function showReturnedDocGrid(e) {
    if ($("#returned-documents").hasClass("hidden")) {
        $("#ready-documents").addClass("hidden");
        $("#returned-documents").removeClass("hidden");
        $(".show-returned-js").removeClass("third");
        $(".show-finished-js").addClass("third");
        $("#returned-documents").trigger("resize");
    }
}

function onProfileMenuLinkClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let sender = $(e.currentTarget);
    let setWrapper = sender.data("setwrapper") == true;
    requestOptionalUrl(
        sender.attr("href"),
        {
            success: (data) => {
                if (data) {
                    if (setWrapper) {
                        data = `<div class="fullwidth step-box"><div class="step-box-body">${data}</div></div>`;
                    }
                    $(".content-wrap-js").html(data);

                    let li = sender.parent();
                    li.parent().find("li").each((index, item) => { $(item).removeClass("active"); })
                    li.addClass("active");
                    li.closest("aside").show();
                }
            }
        });
}

function onDenyPowerOfAttorneyClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let grid = getGrid($(e.currentTarget));
    if (!grid) {
        return;
    }

    let selectedItem = getSelectedItemByTr($(e.currentTarget).closest("tr"));
    if (!selectedItem) {
        return;
    }

    openKendoWindow(
        "DenyPowerOfAttorney",
        "Account",
        {
            data: {
                id: selectedItem["Id"]
            }
        },
        {
            title: getResource("EditPersonalData"),
            width: "30%",
            resizable: true,
            modal: true,
            close: (e) => {
                if (e.userTriggered) {
                    return;
                }

                let success = e.sender.element.data("success");
                if (success === true) {
                    grid.dataSource.read();
                }
            }
        });
}

function onAddAgentPopupClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let grid = $("#AgentsGrid").data("kendoGrid");
    if (!grid) {
        return;
    }

    openKendoWindow(
        "AddRepresentative",
        "Account",
        {
            data: {
                key: grid.element.data("key"),
            },
        },
        {
            title: getResource("AddRepresentative"),
            width: "80%",
            resizable: true,
            modal: true,
            close: (e) => {
                if (e.userTriggered) {
                    return;
                }

                let success = e.sender.element.data("success");
                if (success === true) {
                    grid.dataSource.read();
                }
            }
        });
}

function onChangePersonalDataClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();
    openKendoWindow(
        "UpdatePersonalData",
        "Account",
        {},
        {
            title: getResource("UpdatePersonalData"),
            width: "80%",
            resizable: true,
            modal: true,
        });
}

function onAddAgentClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();
    let sender = $(e.currentTarget);
    let form = sender.closest("form");
    let knik = form.find("#knik").val() as string;
    const regex = /^\d+$/g;
    if (!knik || !regex.test(knik)) {
        displayMessage(getResource("InvalidData"), messageType.warning);
        return;
    }

    requestOptional(
        "FindAgentByKnik",
        "Account",
        {
            data: { knik: form.find("#knik").val() },
            success: (data => {
                if (data) {
                    form.find("#nameAndKnik").html(data);
                    displayMessage(getResource("SuccessAction"), messageType.success);
                } else {
                    displayMessage(getResource("ClientNotFound"), messageType.warning);
                }
            })
        })
}

function onRemoveNewAgentClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();
    let sender = $(e.currentTarget);
    confirmDelete(
        () => {
            sender.closest("#nameAndKnik").html("");
            return true;
        });
}

export function onRegisterTypeChanged(e: kendo.ui.RadioGroupChangeEvent): void {
    let element = $(e.sender.element);

    let sectionWrapper = element.closest("form");
    sectionWrapper.find("div.registerType-js").each(function () {
        let registerDiv = $(this);
        let registerType = e.sender.value();
        let activeSelectorClass = `${registerType}-js`.toLowerCase();
        if (registerDiv.hasClass(activeSelectorClass)) {
            registerDiv.show();
            registerDiv.find("input").prop('disabled', false);
        } else {
            registerDiv.hide();
            registerDiv.find("input").prop('disabled', true);
        }
    });
}

function onAddNameClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let sender = $(e.currentTarget);
    let input = sender.parent().prev().find("input").last();
    let index = kendo.guid();

    let indexInput = input.prev("input[name*='Index']").clone();

    if (indexInput.length == 0) {
        indexInput = $('<input>').attr({
            type: 'hidden',
            name: `${input.attr("name").split("[")[0]}.Index`,
            value: index
        }) as JQuery<HTMLInputElement>;
    }

    indexInput.val(index);

    let newInput = input.clone();
    newInput.val("").attr("id", kendo.guid()).attr("name", `${input.attr("name").split("[")[0]}[${index}]`);

    indexInput.insertAfter(input)
    newInput.insertAfter(indexInput);

    let newButton = sender.clone();
    newButton.removeClass("add-name-js").addClass("remove-name-js").html(getResource("Remove"));
    newButton.insertAfter(sender);
}

function onRemoveNameClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let sender = $(e.currentTarget);
    let buttonsWrapper = sender.closest(".form-input");
    let inputsWrapper = buttonsWrapper.prev();

    let index = buttonsWrapper.find("button.names-button").index(sender);
    if (index && index > -1) {
        let input = inputsWrapper.find(".names-input").eq(index);
        input.prev("input[name*='Index']").remove();
        input.remove();
        sender.remove();
    }
}

function getClientTypeById(id: string): string {

    switch (id) {
        case "5703695c-ae9e-46a3-988a-c4e8831802d0":
            {
                return "physical";
            }
        case "c7d444cd-8145-4553-9b17-25214e3ad403":
            {
                return "legal";
            }
        case "ed83a08a-05be-4b2d-bf8c-cbd5919255a2":
            {
                return "foreignphysical";
            }
        case "288f3329-0f4f-4885-a288-94a9e65966c7":
            {
                return "foreignlegal";
            }
        case "6e242e07-347c-476f-80d2-688aa0acb61b":
            {
                return "physicalwithbulstat";
            }
    }
}

function onCheckExistenceClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let clientTypesDropDown = $("#clientTypes").data("kendoDropDownList");
    if (!clientTypesDropDown) {
        return;
    }

    let identifier = $("#Identifier").val();
    if (!identifier) {
        displayMessage(kendo.format(getResource("Required"), getResource("Identifier")), messageType.warning);
        return;
    }

    let clientType = clientTypesDropDown.dataItem();
    requestOptional(
        "CheckExistence",
        "Account",
        {
            data: {
                clientType: clientType.Id,
                identifier: identifier
            },
            success: (data) => {

                let wrapper = $(".registrationWrapper-js");
                if (!wrapper) {
                    return;
                }

                if (data && data.exists) {
                    displayMessage(getResource("existMessage"), messageType.info);

                    if (!wrapper.hasClass("hidden")) {
                        wrapper.addClass("hidden");
                    }
                } else {
                    let clientTypeDropDown = $("input.clientType-js").data("kendoDropDownList");
                    if (!clientTypeDropDown) {
                        return;
                    }

                    clientTypeDropDown.value(clientType.Id);
                    clientTypeDropDown.trigger("change");
                    clientTypeDropDown.readonly(true);

                    let identifierInput = $(".egnbulstat-js:not(:disabled)");
                    if (!identifierInput) {
                        return;
                    }

                    identifierInput.val(identifier)
                    identifierInput.prop('readonly', true);

                    if (wrapper.hasClass("hidden")) {
                        wrapper.removeClass("hidden");
                    }
                }
            }
        });
}

function onAddRoleClick(e: JQuery.TriggeredEvent): void {
    e.preventDefault();

    let dropDown = $("#RolesDropDown").data("kendoDropDownList");
    if (!dropDown) {
        return;
    }

    let listView = $("#RolesListView").data("kendoListView");
    if (!listView) {
        return;
    }

    if (dropDown.dataItem() && dropDown.dataItem().Id == undefined) {
        displayMessage(getResource("pleaseChoose"), messageType.warning)
        return;
    }

    if (listView.dataSource.get(dropDown.dataItem().Id) != undefined) {
        displayMessage(getResource("itemExistsInList"), messageType.warning)
        return;
    }

    listView.dataSource.add({ Role: dropDown.dataItem() });
}

init();

export function onPeriodStatisticDateChange(e: kendo.ui.DatePickerChangeEvent) {
    let dataId = e.sender.element.data("dataid")
    let periodFrom = $(`#periodFrom_${dataId}`).data("kendoDatePicker").value();
    let periodTo = $(`#periodTo_${dataId}`).data("kendoDatePicker").value();

    requestOptional(
        "GetDashboardDataByPeriod",
        "Account",
        {
            type: "POST",
            data: {
                from: kendo.toString(periodFrom, "dd/MM/yyyy"),
                to: kendo.toString(periodTo, "dd/MM/yyyy")
            },
            success: (res) => {
                $(`#finished-doc_${dataId}`).text(res.CountFinishedIndoc)
                $(`#all-doc_${dataId}`).text(res.CountRegisteredIndoc)
                $(`#approved-doc_${dataId}`).text(res.CountApprovedPayment)
            }
        }
    )
}

export function onClientTypeChanged(e: kendo.ui.DropDownListChangeEvent): void {
    let sender = e.sender;
    let clientTypeSectionWrapper = sender.element.closest(sender.element.data("selectorwrapper"));
    let activeSelectorClass = `${getClientTypeById(sender.value())}-js`;

    clientTypeSectionWrapper.find("div.clientType-js").each((index, item) => {
        let clientTypeDiv = $(item);
        if (clientTypeDiv.hasClass(activeSelectorClass)) {
            clientTypeDiv.show();
            enableInputs(clientTypeDiv, true);
        } else {
            clientTypeDiv.hide();
            enableInputs(clientTypeDiv, false);
        }
    });
}

export function onClientTypeDropDownDataBound(e: kendo.ui.DropDownListDataBoundEvent): void {
    e.sender.trigger("change");
}

export function onCheckGeneralTerms(e: kendo.ui.CheckBoxChangeEvent): void {
    let button = $(e.sender.element.data("buttonselector"));
    if (!button) {
        return;
    }

    button.prop("disabled", !e.sender.check());
}

export function onSpecRoleCheck(e: kendo.ui.CheckBoxChangeEvent): void {

    let dropDown = $("#RolesDropDown").data("kendoDropDownList");
    if (dropDown) {
        dropDown.enable(e.sender.check());
    }

    let button = $(".add-role-js");
    if (button) {
        button.prop("disabled", !e.sender.check());
    }

    $(".rolesWrapper-js").find("input").each((index, item) => {
        $(item).prop("disabled", !e.sender.check());
    });
}

////export function onAddAgentSuccessCallBack(data): void {
////    let window = $(this).closest(".k-window-content").data("kendoWindow");
////    if (!window) {
////        return;
////    }

////    if (data.success) {
////        let grid = $("#AgentsGrid").data("kendoGrid");
////        if (!grid) {
////            return;
////        }

////        grid.dataSource.read();

////        window.close();
////    } else {
////        window.content(data.result);
////    }
////}